import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

const RequireRole = ({ allowedRoles }) => {
    const { userData, loading } = useSelector(
        (state) => state.workerInfo
    );

    if (loading) {
        return <div>Loading...</div>;
    }

    if (!userData) {
        return null;
    }

    if (!allowedRoles.includes(userData.role_id)) {
        return <Navigate to="/panel" replace />;
    }

    return <Outlet />;
};

export default RequireRole;
